import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, MonoTypeOperatorFunction } from 'rxjs';
import { tap, timeout } from 'rxjs/operators';
import { BYPASS_INTERCEPTOR } from '@app/interceptors/auth-interceptor';
import { environment } from '@src/environments/environment';

export interface IngresoCrm {
  evento_id: string; usuario_id: number; usuario_nombre: string;
  sede_id: number | null; recibido_en: string; origen: string;
}
export interface HistorialIngresos { data: IngresoCrm[]; total: number; page: number; size: number; }

@Injectable({ providedIn: 'root' })
export class IngresosCrmService {
  private readonly url = environment.urlAsistencias + 'sgs-observabilidad/api/ingresos-crm';
  constructor(private http: HttpClient) {}

  /** Solo se conecta al POST de sign-in; no a F5, refresh ni recuperación de sesión. */
  observarLogin<T extends { rpta: number; data?: { token?: string } | null }>(): MonoTypeOperatorFunction<T> {
    return origen => origen.pipe(tap(respuesta => {
      if (respuesta.rpta !== 1 || !respuesta.data?.token) return;
      // Una falla de auditoría, incluso síncrona, nunca cambia la respuesta de Java.
      try {
        this.http.post(this.url, { evento_id: crypto.randomUUID() }, this.opciones(respuesta.data.token))
          .pipe(timeout(12000)).subscribe({ error: () => this.aviso() });
      } catch { this.aviso(); }
    }));
  }

  listar(fecha: string, usuarioId: string, page: number): Observable<HistorialIngresos> {
    let params = new HttpParams().set('fecha', fecha).set('page', page).set('size', 20);
    if (usuarioId.trim()) params = params.set('usuario_id', usuarioId.trim());
    return this.http.get<HistorialIngresos>(this.url, {
      ...this.opciones(localStorage.getItem('token') || ''), params
    }).pipe(timeout(15000));
  }

  private opciones(token: string) {
    return { context: new HttpContext().set(BYPASS_INTERCEPTOR, true),
      headers: new HttpHeaders({ Authorization: `Bearer ${token}` }) };
  }
  private aviso(): void {
    console.warn('[Ingresos] No se pudo confirmar el registro de auditoría. El inicio de sesión continúa.');
  }
}
